import { fetchWithAuthInterceptor } from "../utils/fetchAuthInterceptor";
import { API_VERSION } from "../utils/commonConstant";

const API_BASE_URL = `${process.env.REACT_APP_BASE_API_URL}${API_VERSION}`;
const USER_ID = `${process.env.REACT_APP_WEB_API_USER_ID}`;
const KEY = `${process.env.REACT_APP_WEB_API_SECRET_KEY}`;

export const buildApiLoginToken = async () => {
    const loginUrl = `${API_BASE_URL}login`;

    try {
        const response = await fetchWithAuthInterceptor(
            loginUrl,
            {
                headers: {
                    "Content-Type": "application/json"
                },
                method: "POST",
                body: JSON.stringify({
                    userId: USER_ID,
                    applicationSecurityKey: KEY
                }),
            }
        );
        if (!response.ok) {
            console.error("Network response was not ok");
            throw new Error("Network response was not ok");
        }

        const result = await response.json();

        if (result != null) {
            // The Bearer Token is stored in the
            return result.Token;
        } else {
            console.error("Invalid Response");
            throw new Error("Invalid Response");
        }
    } catch (err) {
        console.error("Error in buildApiLoginToken", err);
        throw new Error(err.message);
    }
};

// Attempts to get cached Bearer Token, if not set then request a new token from the API and
export const getOrRefreshBearerToken = async () => {
    console.log("Entered getOrRefreshBearerToken");
    try {
        let bearerToken = localStorage.getItem("Bearer-Token");

        if (bearerToken === "null" || bearerToken === null || bearerToken.length === 0) {
            // No bearer token so get a new one and add it to localstorage
            bearerToken = await buildApiLoginToken();
            localStorage.setItem("Bearer-Token", bearerToken);
        }
        return bearerToken;
    } catch (err) {
        console.error("Error in getOrRefreshBearerToken", err);
        throw new Error(err.message);
    }
};